export default __webpack_public_path__ + "static/media/DL_printing_rules_inches.df1245d0.pdf";